enum DocumentType {
  AdoptionContract = 'AdoptionContract',
  MedicalRecord = 'MedicalRecord',
  IntakeDocument = 'IntakeDocument',
  OwnerSurrenderForm = 'OwnerSurrenderForm',
  TrialRunAgreement = 'TrialRunAgreement',
}

export default DocumentType
